module.exports = __webpack_public_path__ + "static/media/backArrow.c87de518.svg";